/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass } from "@phosphor-icons/react";
import "./StudentDetails.css";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContentLoader from "react-content-loader";

const StudentDetails = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [ID, setID] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [logo, setLogo] = useState(null);
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [sections, setSections] = useState([]);
  const [buttonText, setButtonText] = useState("Add Student");

  const [selectedSection, setSelectedSection] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});

  const [password, setPassword] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 13);

      const response = await api.post("user/userCurl", fd);

      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  const TableLoader = ({ rows = 10, columns = 7 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getClasses";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("student/student", fd);

      if (Array.isArray(modulesResponse.data.data)) {
        setModules(modulesResponse.data.data);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchSections(moduleId) {
    if (!moduleId) {
      setSections([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getSections";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("class_id", moduleId);

      const response = await api.post("student/student", fd);

      if (Array.isArray(response.data.data)) {
        setSections(response.data.data);
      } else {
        setSections([]);
      }
    } catch (error) {
      setSections([]);
    }
  }

  async function fetchData(page = 1, search = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getStudentsPagination";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);
      
      if (search.trim() !== "") {
        fd.append("searchTerm", search.trim());
      }

      const response = await api.post("student/student", fd);

      if (response.data && Array.isArray(response.data.data)) {
        setFetchedData(response.data.data);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      setFetchedData([]);
      setModules([]);
      setSections([]);
    } finally {
      setDataLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setButtonText(ID ? "Updating..." : "Adding...");

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role");

    const fd = new FormData();
    const programType = ID ? "updateStudent" : "addStudent";
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("role", role);

    fd.append("firstName", firstName);
    fd.append("lastName", lastName);
    fd.append("email", email);
    fd.append("phone", mobileNumber);
    fd.append("class_id", selectedModule);
    fd.append("section_id", selectedSection);
    fd.append("rollNo", rollNo);
    fd.append("password", password);
    if (logo) {
      fd.append("logo", logo);
    }

    if (ID) {
      fd.append("id", ID);
    }

    try {
      const response = await api.post("student/student", fd);

      if (response.data.status === true) {
        toast.success(response.data.data);
        fetchData(currentPage, searchTerm);
        handleClose();
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      toast.error("Error submitting form");
    } finally {
      setLoading(false);
      setButtonText("Add Student");
    }
  }

  const handleShowEdit = async (student) => {
    setID(student.id);
    setFirstName(student.first_name || "");
    setLastName(student.last_name || "");
    setEmail(student.email || "");
    setMobileNumber(student.mobileNumber || "");
    setRollNo(student.roll || "");

    const selectedClass = modules.find(
      (c) => c.className === student.className
    );

    if (selectedClass) {
      setSelectedModule(selectedClass.id);
      await fetchSections(selectedClass.id);
      
      setTimeout(() => {
        const selectedSec = sections.find(
          (s) => s.sectionName === student.sectionName
        );
        if (selectedSec) {
          setSelectedSection(selectedSec.id);
        }
      }, 300);
    }

    setPassword("");
    setButtonText("Update Student");
    setShow(true);
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this student?")) return;
    
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteStudent";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      await api.post("student/student", fd);
      toast.success("Student details deleted successfully");
      fetchData(currentPage, searchTerm);
    } catch (error) {
      toast.error("Error deleting student");
    } finally {
      setLoading(false);
    }
  }

  const handleShowAdd = () => {
    resetForm();
    setButtonText("Add Student");
    setShow(true);
  };

  const handleClose = () => {
    resetForm();
    setShow(false);
  };

  const resetForm = () => {
    setID(null);
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobileNumber("");
    setRollNo("");
    setPassword("");
    setSelectedModule("");
    setSelectedSection("");
    setImagePreview(null);
    setLogo(null);
    setButtonText("Add Student");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setLogo(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page, searchTerm);
    }
  };

  useEffect(() => {
    fetchModules();
    fetchSections();
    fetchData();
  }, []);

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                  Student Management
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  <Link to="/" style={{ color: "#64748b", textDecoration: "none" }}>Home</Link>
                  <span>›</span>
                  <span style={{ color: "#3E80F9" }}>Student Details</span>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search students..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "280px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, searchTerm)}
                  />
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add Student
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Students Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "900px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "48px",
                        minWidth: "48px",
                        maxWidth: "48px",
                        padding: "14px 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Name
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Email
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Mobile
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Class
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Section
                    </th>
                    {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "#475569",
                          textTransform: "uppercase",
                          letterSpacing: "0.4px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>

                {dataLoading ? (
                  <TableLoader rows={6} columns={7} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={7} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              👨‍🎓
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No students found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm
                                ? "Try adjusting your search"
                                : "Add your first student"}
                            </div>
                            {!searchTerm && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleShowAdd}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Add First Student
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((student, index) => (
                        <tr key={student.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s"
                        }}>
                          <td
                            style={{
                              width: "48px",
                              minWidth: "48px",
                              maxWidth: "48px",
                              padding: "6px",
                              fontSize: "12px",
                              color: "#64748b",
                              fontWeight: "500",
                              textAlign: "center",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#475569",
                                margin: "0 auto"
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap"
                            }}>
                              {student.first_name} {student.last_name}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{ fontSize: "13px", color: "#334155" }}>
                              {student.email}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{ fontSize: "13px", color: "#334155" }}>
                              {student.mobileNumber}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{ fontSize: "13px", color: "#334155" }}>
                              {student.className}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{ fontSize: "13px", color: "#334155" }}>
                              {student.sectionName}
                            </div>
                          </td>

                          {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                            <td style={{ padding: "12px", textAlign: "center" }}>
                              <div style={{
                                display: "flex",
                                gap: "6px",
                                justifyContent: "center",
                                flexWrap: "wrap"
                              }}>
                                {userPermissions.is_edit === "1" && (
                                  <button
                                    onClick={() => handleShowEdit(student)}
                                    title="Edit Student"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#eff6ff",
                                      color: "#3b82f6",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#dbeafe"}
                                    onMouseLeave={(e) => e.target.style.background = "#eff6ff"}
                                  >
                                    <PencilSimpleLine size={14} />
                                  </button>
                                )}

                                {userPermissions.is_delete === "1" && (
                                  <button
                                    onClick={() => handleDelete(student.id)}
                                    title="Delete Student"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#fef2f2",
                                      color: "#dc2626",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#fee2e2"}
                                    onMouseLeave={(e) => e.target.style.background = "#fef2f2"}
                                  >
                                    <Trash size={14} />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Compact Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />

      {/* Modal for adding/editing students */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "14px 24px",
          background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
          color: "#fff"
        }}>
          <div>
            <Modal.Title style={{ fontSize: "20px", fontWeight: "700", marginBottom: "4px", color: "#fff" }}>
              {ID ? "✏️ Edit Student" : "➕ Add New Student"}
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body style={{
          padding: "28px",
          background: "#f8fafc"
        }}>
          <form onSubmit={handleSubmit} id="student-details-form">
            {/* Photo Upload */}
            <div className="mb-4">
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Your Photo
              </label>
              <div style={{ display: "flex", gap: "22px", alignItems: "center" }}>
                <div style={{ flexShrink: 0 }}>
                  <div
                    style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "12px",
                      backgroundImage: `url(${imagePreview || "https://static.vecteezy.com/system/resources/thumbnails/013/360/247/small/default-avatar-photo-icon-social-media-profile-sign-symbol-vector.jpg"})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      border: "2px solid #e2e8f0"
                    }}
                  />
                </div>
                <div style={{
                  flex: 1,
                  textAlign: "center",
                  position: "relative",
                  padding: "24px 4px",
                  borderRadius: "16px",
                  border: "2px dashed #3E80F9",
                  background: "#eff6ff",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#dbeafe"}
                onMouseLeave={(e) => e.currentTarget.style.background = "#eff6ff"}
                >
                  <input
                    type="file"
                    id="imageUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleImageChange}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                      zIndex: 1
                    }}
                  />
                  <span style={{ fontSize: "32px", color: "#3E80F9", display: "inline-block" }}>
                    <i className="ph ph-upload" />
                  </span>
                  <span style={{
                    fontSize: "13px",
                    display: "block",
                    color: "#64748b",
                    margin: "8px 0"
                  }}>
                    Click to upload or drag and drop
                  </span>
                  <span style={{
                    fontSize: "13px",
                    display: "block",
                    color: "#3E80F9"
                  }}>
                    SVG, PNG, JPEG OR GIF (max 1080px × 1200px)
                  </span>
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  First Name <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Last Name <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Email <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="email"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Mobile Number <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Roll Number <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter Roll Number"
                  value={rollNo}
                  onChange={(e) => setRollNo(e.target.value)}
                  required
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Password <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="password"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required={!ID}
                />
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Select Class <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <select
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  value={selectedModule}
                  onChange={(e) => {
                    const moduleId = e.target.value;
                    setSelectedModule(moduleId);
                    fetchSections(moduleId);
                  }}
                  required
                >
                  <option value="">Select a Class</option>
                  {modules.map((module) => (
                    <option key={module.id} value={module.id}>
                      {module.className}
                    </option>
                  ))}
                </select>
              </div>
              
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Select Section <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <select
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  value={selectedSection}
                  onChange={(e) => setSelectedSection(e.target.value)}
                  required
                >
                  <option value="">Select a Section</option>
                  {sections.map((section) => (
                    <option key={section.id} value={section.id}>
                      {section.sectionName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer style={{
          borderTop: "1px solid #e5e7eb",
          padding: "24px 28px",
          background: "#f8fafc"
        }}>
          <Button 
            variant="secondary" 
            onClick={handleClose}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {buttonText}
              </>
            ) : (
              buttonText
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          select:hover, input:hover {
            border-color: #94a3b8 !important;
          }
          
          select:focus, input:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default StudentDetails;